import googleAnalytics from '@analytics/google-analytics';
import Analytics from 'analytics';

function decimalPlaces(num) {
    var result = 0;
    var match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
    if (match) {
        result = Math.max(
            0,
            // Number of digits right of decimal point.
            (match[1] ? match[1].length : 0) -
                // Adjust for scientific notation.
                (match[2] ? +match[2] : 0)
        );
    }
    return result;
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;

    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    var results = regex.exec(url);

    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function getCookieValue(a) {
    var b = document.cookie.match(new RegExp('(^|;)\\s*' + a + '\\s*=\\s*(true|false)'));
    return b ? b[2] === 'true' : false;
}

function isInViewport(elem) {
    var distance = elem.getBoundingClientRect();
    return distance.top >= 0 && distance.left >= 0 && distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) && distance.right <= (window.innerWidth || document.documentElement.clientWidth);
}

function analytics(trackingId) {
    return Analytics({
        plugins: [
            googleAnalytics({
                trackingId: trackingId,
                anonymizeIp: true
            })
        ]
    });
}

export { analytics, decimalPlaces, getCookieValue, getParameterByName, isInViewport };
